import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BasePeriodicBackup from '../../AbstractObjects/GatewayPlan/InnerPages/BasePeriodicBackup';

const pageSchema = GatewayGetSchema.pages.serviceBackup;
const pageId = pageSchema.pageId;

function PlanPeriodicBackup({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BasePeriodicBackup
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanPeriodicBackup;